import React, { useState, useEffect, Fragment } from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(1),
    marginLeft: "0px"
  }
}));

export default function MethodChip({ method }) {
  const classes = useStyles();
  const [value, setValue] = useState(null);

  useEffect(() => {
    switch (method) {
      case "get":
        setValue({
          label: "get",
          backgroundColor: "#2F8132",
          color: "white"
        });
        break;
      case "put":
        setValue({
          label: "put",
          backgroundColor: "#95507C",
          color: "white"
        });
        break;
      case "post":
        setValue({
          label: "post",
          backgroundColor: "#186FAF",
          color: "white"
        });
        break;
      case "delete":
        setValue({
          label: "delete",
          backgroundColor: "#CC3333",
          color: "white"
        });
        break;
      case "options":
        setValue({
          label: "options",
          backgroundColor: "#947014",
          color: "white"
        });
        break;
      case "head":
        setValue({
          label: "head",
          backgroundColor: "#A23DAD",
          color: "white"
        });
        break;
      case "patch":
        setValue({
          label: "patch",
          backgroundColor: "#BF581D",
          color: "white"
        });
        break;
      case "trace":
        setValue({
          label: "trace",
          backgroundColor: "yellow",
          color: "black"
        });
        break;
      case "subscribe":
        setValue({
          label: "subscribe",
          backgroundColor: "#38A169",
          color: "white"
        });
        break;
      case "publish":
        setValue({
          label: "publish",
          backgroundColor: "#3182CE",
          color: "white"
        });
        break;
      default:
        break;
    }
  }, [method]);

  return (
    <Fragment>
      {value && (
        <Chip
          size="small"
          label={value.label.toUpperCase()}
          className={classes.chip}
          style={{ backgroundColor: value.backgroundColor, color: value.color }}
        />
      )}
    </Fragment>
  );
}
